<template>
  <div class="section">
    <TableFilter :filters="filtersPerType[$route.params.type]"
      :key="$route.params.type" @input="query => $router.push({ query, offset: 0, limit: 10 })"/>
    <EmployeeTable :query="query"
      @pageChange="(p) => $router.push({ query: { ...$route.query, offset: 10 * (p - 1) } })" />
  </div>
</template>
<script>
import EmployeeTable from '@/components/Tables/EmployeeTable';
import TableFilter from '@/components/TableFilter';
import { mapState } from 'vuex';


export default {
  data() {
    return {
      baseQuery: { order: '-created', limit: 10, offset: 0 },
      filterQuery: {},
    };
  },
  computed: {
    ...mapState({
      countries: state => state.content.countries,
      employment_positions: state => state.content.employment_positions,
      languages: state => state.content.skills.Languages,
      dockServicesSkills: state => state.content.skills['Dock Services'],
      qualifications: state => state.content.qualifications,
    }),
    query() {
      return { ...this.baseQuery, ...this.$route.query, type: this.$route.params.type };
    },
    filtersPerType() {
      return {
        crew: [
          {
            type: 'MultipleAutoCompleteFilter',
            queryKey: 'profile__desired_employment_positions',
            key: 'profile__desired_employment_positions',
            label: 'Position',
            props: {
              options: this.employment_positions.filter(
                p => ['Shipyard/Dock Services', 'Diver'].indexOf(p) === -1,
              ),
            },
          },
          {
            type: 'OptionFilter',
            queryKey: 'profile__gender',
            key: 'profile__gender',
            label: 'Gender',
            props: {
              options: ['male', 'female'],
            },
          },
          {
            type: 'MultipleAutoCompleteFilter',
            queryKey: 'profile__current_country',
            key: 'profile__current_country',
            label: 'Country',
            props: { options: this.countries },
          },
          {
            type: 'TextFilter',
            queryKey: 'profile__current_harbor__icontains',
            key: 'profile__current_harbor__icontains',
            label: 'Harbor',
            props: { options: this.countries },
          },
          {
            type: 'NumberRangeFilter',
            queryKey: 'profile__age',
            key: 'profile__age',
            label: 'Age',
          },
          {
            type: 'NumberRangeFilter',
            queryKey: 'profile__experience_years',
            key: 'profile__experience_years',
            label: 'Experience (years)',
          },
          {
            type: 'DateRangeFilter',
            queryKey: 'available',
            key: 'available',
            label: 'Availability',
          },
          {
            type: 'MultipleAutoCompleteFilter',
            queryKey: 'profile__skill__name',
            key: 'languages',
            label: 'Languages',
            props: { options: this.languages },
          },


        ],
        on_dock: [
          {
            type: 'MultipleAutoCompleteFilter',
            queryKey: 'profile__skills',
            key: 'dock_skills',
            label: 'Dock Skills',
            props: { options: this.dockServicesSkills },
          },
          {
            type: 'MultipleAutoCompleteFilter',
            queryKey: 'profile__skill__name',
            key: 'languages',
            label: 'Languages',
            props: { options: this.languages },
          },
          {
            type: 'MultipleAutoCompleteFilter',
            queryKey: 'profile__current_country',
            key: 'profile__current_country',
            label: 'Country',
            props: { options: this.countries },
          },
          {
            type: 'TextFilter',
            queryKey: 'profile__current_harbor__icontains',
            key: 'profile__current_harbor__icontains',
            label: 'Harbor',
            props: { options: this.countries },
          },
        ],
        charterer: [
          {
            type: 'MultipleAutoCompleteFilter',
            queryKey: 'profile__current_country',
            key: 'profile__current_country',
            label: 'Country',
            props: { options: this.countries },
          },
          {
            type: 'TextFilter',
            queryKey: 'profile__current_harbor__icontains',
            key: 'profile__current_harbor__icontains',
            label: 'Harbor',
            props: { options: this.countries },
          },
          {
            type: 'MultipleAutoCompleteFilter',
            queryKey: 'profile__skill__name',
            key: 'languages',
            label: 'Languages',
            props: { options: this.languages },
          },
          {
            type: 'NumberRangeFilter',
            queryKey: 'profile__age',
            key: 'profile__age',
            label: 'Age',
          },
          {
            type: 'NumberRangeFilter',
            queryKey: 'profile__experience_years',
            key: 'profile__experience_years',
            label: 'Experience(years)',
          },
        ],
        diver: [
          {
            type: 'MultipleAutoCompleteFilter',
            queryKey: 'profile__current_country',
            key: 'profile__current_country',
            label: 'Country',
            props: { options: this.countries },
          },
          {
            type: 'TextFilter',
            queryKey: 'profile__current_harbor__icontains',
            key: 'profile__current_harbor__icontains',
            label: 'Harbor',
            props: { options: this.countries },
          },
          {
            type: 'MultipleAutoCompleteFilter',
            queryKey: 'profile__skill__name',
            key: 'languages',
            label: 'Languages',
            props: { options: this.languages },
          },
          {
            type: 'NumberRangeFilter',
            queryKey: 'profile__experience_years',
            key: 'profile__experience_years',
            label: 'Experience(years)',
          },
          {
            type: 'MultipleAutoCompleteFilter',
            queryKey: 'profile__qualifications',
            key: 'profile__qualifications',
            label: 'Qualification',
            props: { options: this.qualifications.Diving },
          },
        ],
      };
    },
  },
  components: {
    EmployeeTable,
    TableFilter,
  },
};
</script>
